import { ApiRoute } from 'config';
import { AddressesContext, ContextValue } from 'contexts/Addresses';
import createUseContextHook from './createUseContextHook';

const useAddresses = createUseContextHook<ContextValue>(
  // @ts-expect-error TODO: fix null safety
  AddressesContext,
  ApiRoute.SHIPPING_ADDRESSES,
);

export default useAddresses;
